<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Veículo" prop="veiculo_id" :rules="[$requiredChange]" key="veiculo_id">
              <el-select v-model="dados.veiculo_id" placeholder="pesquisar..." filterable remote :remote-method="getVeiculoByFilter" :loading="loadingVeiculo">
                <el-option v-for="v in veiculos" :key="v.id" :label="v.placa" :value="v.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Data" prop="data" :rules="[$requiredChange]" key="data">
              <el-date-picker v-model="dados.data" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Tipo" prop="tipo" :rules="[$requiredBlur]" key="tipo">
              <el-input v-model="dados.tipo" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Valor" prop="valor" :rules="[$requiredBlur]" key="valor">
              <el-input v-model="dados.valor" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="KM" prop="km" key="km">
              <el-input v-model="dados.km" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item label="Descrição" prop="descricao" key="descricao">
              <el-input type="textarea" :rows="3" v-model="dados.descricao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-manutencao" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    edit: false,
    filtroInstituicao: { id: '', nome: '' },
    loadingVeiculo: false,
    veiculos: [],
    dados: {
      id: '',
      instituicao_id: '',
      veiculo_id: '',
      tipo: '',
      descricao: '',
      data: '',
      valor: '',
      km: ''
    }
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
  },
  methods: {
    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    getVeiculoByFilter (query) {
      if (!query || query.length < 2) { this.veiculos = []; return }
      this.loadingVeiculo = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/veiculo/searchByPlaca`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.veiculos = JSON.parse(JSON.stringify(res.data)); this.loadingVeiculo = false })
        .catch(e => { this.loadingVeiculo = false; this.$store.commit('throwException', e) })
    },
    async getById (id) {
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/manutencao/getById/` + id, this.$store.getters.getHeaderAuth)
      const data = JSON.parse(JSON.stringify(res.data))
      if (data && data.veiculo) { this.veiculos = [{ id: data.veiculo.id, placa: data.veiculo.placa }]; delete data.veiculo }
      this.dados = data
    },
    onSubmit () {
      document.getElementById("btn-manutencao").focus()
      this.$refs.dados.validate(async (valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        try {
          this.dados.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null
          if (this.edit) {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/manutencao/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
          } else {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/manutencao/store`, this.dados, this.$store.getters.getHeaderAuth)
          }
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$emit('onSubmitManutencao')
        } catch (e) {
          window.eventBus.$emit('loading', false)
          this.$store.commit('throwException', e)
        }
      })
    }
  },
  watch: {
    paramId: {
      immediate: true,
      async handler (value) {
        if (value) {
          this.edit = true
          await this.getById(value)
        }
      }
    }
  }
}
</script>

